module.exports = __webpack_public_path__ + "img/MOvies.4f567b68.jpg";